import * as React from 'react';
import Viewer from 'bpmn-js/lib/Viewer';
import 'bpmn-js/dist/assets/diagram-js.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
import 'bpmn-js/dist/assets/bpmn-js.css';
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Grid, IconButton, Modal, Paper, Stack, Tooltip, Typography } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import BugReportIcon from '@mui/icons-material/BugReport';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { styled } from '@mui/material/styles';
import diagramXML from '../../../resources/newDiagram.bpmn';
import "../BpmnPanel.css";
import Service from '../../../util/Service';
import AlertDialog from '../../util/AlertDialog';
import { ArrowBack } from '@mui/icons-material';

var viewer = null;

const Item = styled(Typography)(({ theme }) => ({
    color: 'red'

}));
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    minHeight: 200,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 1,
};


export default function FlowPanel() {
    let bpmnPanel = React.useRef(null);
    const params = useParams();
    const [processo, setProcesso] = React.useState();
    const [processoBG, setProcessoBG] = React.useState();
    const [node, setNode] = React.useState();
    const [userTask, setUserTask] = React.useState();
    const [open, setOpen] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [elapsedTime, setElapsedTime] = React.useState(0);

    const [openModal, setOpenModal] = React.useState(false);

    const handleClose = () => setOpenModal(false);

    const [trigger, setTriger] = React.useState(false);

    React.useEffect(() => {
        if (!viewer) {
            const container = bpmnPanel.current;
            viewer = new Viewer({
                container,
                // moddleExtensions: {
                //     custom: customModdleExtension
                // }
            });
            viewer.on('import.done', handleImporDone);
            if (!(params && params.id)) {
                callOnInit();
            }
        }

        if (params && params.id) {
            buscaUserTask(params.id);
        }
    }, []);
    React.useEffect(() => {
        if (trigger) {
            buscaTempoExecucaoProcessoBG();
        }
    }, [trigger]);
    React.useEffect(() => {
        printPath();
        if (processoBG && processoBG.status === 'RUNNING') {
            if (!trigger) setTriger(true);
        }
    }, [processoBG]);
    function buscaUserTask(id) {
        Service.GET("/api/security/backGroundTask/buscaPorId/" + id).then(ret => {
            setProcesso(ret.processoBPMN);
            setUserTask(ret.userTask)
            buscaGridFSFileById(ret);//.processoBPMN.idBpmn)
        });
    }
    function buscaTempoExecucaoProcessoBG() {
        Service.GET("/api/bpmn/verTempoExecPBG/" + processoBG.id).then(ret => {
            setElapsedTime(ret.elapsedTime ? ret.elapsedTime : 0)
        });
    }
    function handleFluxoCodigoQuebrado() {
        setMsg("Fluxo de report de erro de codigo não implementado");
        setOpen(true);
    }
    function handleReprocessar() {
        Service.GET("/api/bpmn/reprocessar/" + processoBG.id).then(ret => {
            if (!ret.success) {
                setOpen(true);
                setMsg(ret.msg);
            } else {
                setProcessoBG(ret.processoBG)
            }
        });
    }
    function handleLimpaListaErro() {
        Service.GET("/api/bpmn/processErroClean/" + processoBG.id).then(ret => {
            if (!ret.success) {
                setOpen(true);
                setMsg(ret.msg);
            } else {
                setElapsedTime(0);
                setProcessoBG(ret.processoBG)
            }
        });
    }
    function handleStop() {
        Service.GET("/api/bpmn/stopProcess/" + processoBG.id).then(ret => {
            if (!ret.success) {
                setOpen(true);
                setMsg(ret.msg);
            } else {
                setElapsedTime(0);
                setProcessoBG(ret.processoBG)
            }
        });
    }
    function buscaGridFSFileById(ret) {
        const url = "/api/bpmn/GridFSFileById/" + ret.processoBPMN.idBpmn;
        fetch(url, { headers: { Authorization: `Bearer ${localStorage.accessToken}` } })
            .then(function (response) {
                return response.text();
            })
            .then(function (text) {
                try {
                    viewer.importXML(text);
                    buscaProcessoBackGround(ret.userTask.id);
                } catch (err) {
                    console.error(err)
                }
            })["catch"](function (err) {
                console.error(">>>erro: ", err)
            });
    }

    const buscaProcessoBackGround = (id) => {
        Service.GET("/api/bpmn/buscaProcessoBGPorIdTask/" + id).then(ret => {
            setProcessoBG(ret)
        });
    }
    const printPath = () => {
        if (!userTask) return;
        if (!processoBG) return;

        const elementRegistry = viewer.get('elementRegistry');
        const elements = elementRegistry.getAll();
        var canvas = viewer.get('canvas');

        for (let x in elements) {
            const el = elements[x];
            const id = el.id;
            let done = verificaDone(el);
            if (done) {
                canvas.addMarker(id, 'highlight');
            }
        }
    }
    function verificaDone(el) {
        // if (processoBG && processoBG.status === 'DONE') return true;
        if (el.type === "bpmn:StartEvent") return true;
        if (processoBG) {
            const item = processoBG.lstTask.find(t => t.idTask === el.id);
            if (!item) {
                if (processoBG && processoBG.status === 'DONE') {
                    if (el.type === "bpmn:ExclusiveGateway") return true;
                    if (el.type === "bpmn:EndEvent") return true;
                }

            }
            return item != null;
        }
        return false;
    }
    const handleEvenBusEvent = (e) => {
        setNode(e.element);
        console.log(e.element)
        setOpenModal(true);
    }
    const handleImporDone = (event) => {
        var error = event.error,
            warnings = event.warnings;
        if (error) {
            console.error(error)
            return
        }

        var eventBus = viewer.get('eventBus');
        var events = ['element.mouseup'];

        events.forEach(function (event) {
            eventBus.off(event);
            eventBus.on(event, handleEvenBusEvent);
        });

        viewer.get('canvas').zoom('fit-viewport');

    }
    function callOnInit(nameParameter) {
        fetch(diagramXML).then(function (response) {
            return response.text();
        }).then(function (text) {
            try {
                viewer.importXML(text);
                viewer.get('canvas').zoom('fit-viewport');

            } catch (err) {
                console.error(err)
            }
        })["catch"](function (err) {
            console.error(">>>erro: ", err)
        });
    }

    const PrintErro = () => {
        if (processoBG && processoBG.lstErro && processoBG.lstErro.length > 0) {
            return (
                <Paper elevation={0} sx={{ border: '1px solid black', borderRadius: '8px', padding: '8px', width: '91.7%' }}>
                    <Stack>
                        {processoBG.lstErro.map((e, i) => (
                            <Item key={i}>{(i + 1) + " -> " + e}</Item>
                        ))}
                    </Stack>

                </Paper>
            )
        }
        return (
            <div />
        )
    }
    const Comandos = () => {
        return (
            <Stack spacing={1}>
                {hasErro() &&
                    <div>
                        <Tooltip title="Executar novamente">
                            <IconButton aria-label="reprocessar" color="primary" onClick={handleReprocessar}>
                                <ReplayIcon />
                            </IconButton>
                        </Tooltip>
                    </div>}
                {hasErroCode() &&
                    <div>
                        <Tooltip title="Reportar erro de codigo">
                            <IconButton aria-label="report" color="primary" onClick={handleFluxoCodigoQuebrado}>
                                <BugReportIcon />
                            </IconButton>
                        </Tooltip>
                    </div>}
                {hasRunnitg() &&
                    <div>
                        <Tooltip title="Parar execução do codigo">
                            <IconButton aria-label="stop" color="primary" onClick={handleStop}>
                                <CancelScheduleSendIcon />
                            </IconButton>
                        </Tooltip>
                    </div>}

                {hasListaErro() &&
                    <div>
                        <Tooltip title="Limpar a lista de erro">
                            <IconButton aria-label="stop" color="primary" onClick={handleLimpaListaErro}>
                                <CleaningServicesIcon />
                            </IconButton>
                        </Tooltip>
                    </div>}

            </Stack>
        )
    }

    function hasErroCode() {
        if (processoBG) {
            if (processoBG.status === 'ERRO_CODIGO') return true
        }
        return false;
    }
    function hasErro() {
        if (processoBG) {
            if (processoBG.status === 'ERROR') return true
        }
        return false;
    }
    function hasRunnitg() {
        if (processoBG) {
            if (processoBG.status === 'RUNNING') {
                return true
            }
        }
        return false;
    }
    function hasListaErro() {
        if (processoBG && processoBG.lstErro) {
            return processoBG.lstErro.length > 0
        }
        return false;
    }
    const MontaTempoDecorrido = () => {
        let tempo = elapsedTime / 1000;

        let mask = 'segundos';
        if (tempo > 60) {
            tempo = tempo / 60;
            mask = 'minutos';
            if (tempo > 60) {
                tempo = tempo / 60;
                mask = 'horas';
                if (tempo > 24) {
                    tempo = tempo / 24;
                    mask = 'dias';
                }
            }
        }
        return (
            <Grid size={12}>
                <Item>{"Processo executando em " + Math.floor(tempo) + " " + mask}</Item>
            </Grid>
        )
    }

    const MontaNodeInfo = () => {
        const item = (processoBG && node) ? processoBG.lstTask.filter(t => t.idTask === node.id) : null;
        

        console.log( item );

        if(node && node.type.indexOf("Gateway") > 0){
            console.log( node.id);
            console.log( processo );
            const flow = processo.lstTask.find(t => t.idTask === node.id)
            if( flow){
                return (
                    <ul>

                        {Object.keys(flow.criterio).map((row,i) =>(
                            <li style={{marginBottom: '10px'}} key={i}>{row+": "+flow.criterio[row]}</li>
                        )
                        )}
                    </ul>
                )
            }else
            return (
                <p>Gateway não definido</p>
            )
        }
        const formatted = (item && item.length >0 ) ? JSON.stringify(item[item.length-1], null, 2) : null;
        return (
            <>
                {(item && item.length >0 ) ? (
                    <pre style={{
                        backgroundColor: '#1e1e1e',
                        color: '#d4d4d4',
                        padding: '15px',
                        borderRadius: '5px',
                        fontSize: '14px',
                        wordBreak: 'break-word',
                        overflow: 'auto',
                        lineHeight: '1.5',
                        maxWidth: '900px',
                        maxHeight: '520px'
                    }}>
                        <span style={{ color: '#ce9178' }}>{formatted}</span>
                    </pre>
                ) : (
                    <Typography variant="body2" color="textSecondary">
                        Nenhuma informação disponível.
                    </Typography>
                )}
            </>
        );
    };

    function handleRemoverItem(node){
        const dado = {
            idTask: node.id,
            idBG: processoBG.id
        }
        console.log( dado );
        Service.POST('/api/security/backGroundTask/apagarTask', dado).then( r =>{
            console.log(r);
            if( r.success){
                if (params && params.id) {
                    buscaUserTask(params.id);
                    handleClose();
                }
            }
        })
    }

    return (
        <Grid container spacing={2}>
            {/* {node && 
                <DragAndDrop>
                    <Paper>
                        <MontaNodeInfo />
                    </Paper>
                </DragAndDrop> } */}
            {elapsedTime > 0 && <MontaTempoDecorrido />}
            <Grid size={12}>
                <Typography variant='h4'>{processo && processo.nome }</Typography>
            </Grid>
            <Grid size={11}>
                <div ref={bpmnPanel}
                    style={{
                        height: 400,
                        width: '100%',
                        border: '1px solid #333',
                        borderRadius: '7px',
                        padding: '8px',

                    }}
                />
            </Grid>
            <Grid size={1}>
                <Comandos />

            </Grid>
            <Grid size={12}>
                <PrintErro />
            </Grid>
            <AlertDialog open={open} setOpen={setOpen} msg={msg} title="Alerta" />
            <Modal
                open={openModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction="row" spacing={15}>
                        <Typography id="modal-modal-title" variant="h5" sx={{ fontWeight: 'bold' }}>
                            {node && node.di.bpmnElement.name}
                        </Typography>
                        {node && node.type.indexOf("Gateway") < 0 &&
                        <Button variant="outlined" startIcon={<ArrowBack />} onClick={()=> handleRemoverItem(node.di.bpmnElement)} >
                            Voltar Fluxo
                        </Button>}
                    </Stack>

                    {/* Tipo do Node */}
                    <Typography variant="body1" sx={{ marginBottom: 3 }}>
                        <strong>Tipo:</strong> {node && node.type}
                    </Typography>

                    <MontaNodeInfo id="modal-modal-description" />

                </Box>
            </Modal>

        </Grid>

    )
}